<template>
  <div class="col data-block no-border-block custom-overview-block">
    <div class="block-title">
      <span>
        {{ areaName }}
      </span>
    </div>
    <div class="block-text">
      <strong>{{ openTrails }}</strong>
      <span>/{{ closedTrails }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'OverviewSections',
  props: ['areaName', 'mountainAreas'],
  computed: {
    area() {
      if (this.mountainAreas) {
        return this.mountainAreas.filter(area => area.Name === this.areaName)[0];
      }
    },
    openTrails() {
      if (this.area) {
        return this.area.OpenTrailsCount;
      }
      return '0';
    },
    closedTrails() {
      if (this.area) {
        return this.area.TotalTrailsCount;
      }
      return '0';
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-overview-block {
  .block-title {
    white-space: normal;
    max-width: 110px;
    @media (max-width: $tablet) {
      max-width: 75px;
    }
  }
}
</style>
